import React, {useState, useEffect, useContext} from "react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {DEFAULT_BLUE} from "../constants/general-constants";
import SelectionToolOption from '../components/SelectionToolOption';
import {store} from '../context/store';

export default function SelectionTool({title, value, values, dataLoad}){
	
	const globalState = useContext(store);
	
	const POPUP_HEIGHT = "300px"
	
	const [popupDisplay, setPopupDisplay] = useState("none");
	const [popupHeight, setPopupHeight] = useState("0px");
	const [displayValue, setDisplayValue] = useState(value);
	const [displayValues, setDisplayValues] = useState([]);
	
	useEffect(() => {
		
		if(value){
			setDisplayValue(value);
		}
		
		if(values){
			setDisplayValues(values);
		}
		
		
	}, [values, value]);
	
	
	const thisContainer = {
		display:"flex",
		flexDirection:"column",
		height:"30px",
		marginBottom:"10px",
	}
	
	const mainContainer = {
		display:"flex",
		width:"340px",
		height:"30px",
		minHeight:"30px",
		borderRadius:"4px",
		marginBottom:"10px",
		border:"1px solid grey"
	};
	
	const titleContainer = {
		display:"flex",
		height:"100%",
		marginLeft:"10px",
		width:"calc(50% - 10px)",
		alignItems:"center",
		fontSize:"12px",
		color:'black'
	};
	
	const valueSelector = {
		display:"flex",
		width:"50%",
		height:"100%",
		borderRadius:"20px"
	};
	
	const valueText = {
		display:"flex",
		marginLeft:"20px",
		color:'black',
		fontSize:"12px",
		alignItems:"center",
		height:"100%",
		width:"calc(100% - 40px)"
	};
	
	const iconContainer = {
		display:"flex",
		width:"30px",
		height:"30px",
		alignItems:"center",
		justifyContent:"space-around"
	};

	const iconStyle = {
		display:"flex",
		color:'black',
		cursor:"pointer",
		width:"20px",
		height:"20px"
	};
	
	const selectPopup = () => {
		setPopupHeight(POPUP_HEIGHT);
		setPopupDisplay("flex");
	};
	
	
	const popup = {
		marginTop:"-150px",
		width:"50%",
		marginLeft:"50%",
		backgroundColor:"white",
		flexDirection:"column",
		boxShadow:'0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)',
		zIndex:"2",
		borderRadius:"3px"
	};
	
	const setSelected = (id) => {
		for(var i=0; i<displayValues.length; i++){
			if(displayValues[i].id === id){
				setDisplayValue(displayValues[i].name);
			}
			setPopupDisplay("none");
			setPopupHeight("0px");
			if(dataLoad){
				dataLoad(id, displayValues[i].name);
			}
		}
	};
	
	const optionDisplay = displayValues.map((item, index) => 
		<SelectionToolOption
			id={item.id}
			name={item.name}
			setFunction={setSelected}
		>
		</SelectionToolOption>
	);
	
	const gradientContainer = {
		display:"flex",
		width:"100%",
		height:"100%",
		alignItems:"center",
		borderTopRightRadius:"40px",
		borderBottomRightRadius:"40px"
	};
	
	const handleMouseLeave = () => {
		setPopupDisplay("none");
	};
	
	return (
		<div style={thisContainer}>
			<div style={mainContainer}>
				<div style={gradientContainer}>
					<div style={titleContainer}>
					
						{title}
					</div>
				
					<div style={valueSelector}>
							<div style={valueText}>
								{displayValue}
							</div>
							<div style={iconContainer}>
								<FontAwesomeIcon icon="angle-down" style={iconStyle} onClick={selectPopup}/>
							</div>	
					</div>
				</div>
			</div>
			<div style={{...popup, display:popupDisplay, minHeight:popupHeight}} onMouseLeave={handleMouseLeave}>
				{optionDisplay}
			</div>
		</div>
	);
}